import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { MESSAGE_TOAST } from './../../../../../../shared/enums/message-toast-enum';
import { ToastrService } from 'ngx-toastr';
import { Spinner } from './../../../../../../core/services/spinner.service';
import { FormControl, ValidationErrors } from '@angular/forms';
import { APPLICATION, APPLICATION_KEY } from './../../../../../../shared/enums/admin-enum';
import { APPS } from './../application-access-status/application-access-status.component';
import { Component, OnInit } from '@angular/core';
import { AssignmentGroupService } from 'src/app/shared/service/assignment-group.service';

export const enum REQUEST_TYPE {
  ACCESS_REQUEST = 'access_request',
  REVOKE_REQUEST = 'revoke_request',

}

@Component({
  selector: 'app-assignment-group-management',
  templateUrl: './assignment-group-management.component.html',
  styleUrls: ['./assignment-group-management.component.scss']
})
export class AssignmentGroupManagementComponent implements OnInit {

  apps = [
    {
      id: APPLICATION_KEY.REN_TT,
      name: APPLICATION.REN_TT,
      type: REQUEST_TYPE.ACCESS_REQUEST
    },
    {
      id: APPLICATION_KEY.REN_TM,
      name: APPLICATION.REN_TM,
      type: REQUEST_TYPE.ACCESS_REQUEST
    },
    {
      id: APPLICATION_KEY.RACES_ISUPPLIER,
      name: APPLICATION.RACES_ISUPPLIER,
      type: REQUEST_TYPE.ACCESS_REQUEST
    },
    {
      id: APPLICATION_KEY.SRM,
      name: APPLICATION.SRM,
      type: REQUEST_TYPE.ACCESS_REQUEST
    },
    {
      id: APPLICATION_KEY.RACES_ISUPPLIER,
      name: APPLICATION.RACES_ISUPPLIER,
      type: REQUEST_TYPE.REVOKE_REQUEST
    },
    {
      id: APPLICATION_KEY.GE_TAG_ID,
      name: APPLICATION.GE_TAG_ID,
      type: REQUEST_TYPE.ACCESS_REQUEST
    },
    {
      id: APPLICATION_KEY.EOL_DL,
      name: APPLICATION.EOL_DL,
      type: REQUEST_TYPE.ACCESS_REQUEST
    },
  ];
  selected = '';
  appName: FormControl = new FormControl('');
  type = '';
  title = '';
  listApp: any[] = [];
  
  constructor(
    private assignmentGroupService: AssignmentGroupService,
    private spinner: Spinner,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    const roles = atob(localStorage.getItem(btoa('role')));
    console.log(roles);
    this.router.events.filter(event => event instanceof NavigationEnd)
      .subscribe((res: any) => {
        if (res.urlAfterRedirects.split('/')[3] === PATH_ROUTING.PATH_APPLICATION_ACCESS_ASSIGNMENT) {
          this.type = REQUEST_TYPE.ACCESS_REQUEST;
          this.title = 'Application Access Request Assignment Group Management';
          this.listApp = this.apps.filter(item => item.type === REQUEST_TYPE.ACCESS_REQUEST);
          if (roles.includes('GE_TAG_ID_ADMIN')) {
            this.listApp = this.apps.filter(item => item.id === APPLICATION_KEY.GE_TAG_ID);
          } else if (roles.includes('EOL_ADMIN')) {
            this.listApp = this.apps.filter(item => item.id === APPLICATION_KEY.EOL_DL);
          }
        } else {
          this.type = REQUEST_TYPE.REVOKE_REQUEST;
          this.title = 'Application Revoke Request Assignment Group Management';
          this.listApp = this.apps.filter(item => item.type === REQUEST_TYPE.REVOKE_REQUEST);
        }
        this.selected = this.listApp[0].id;
      });
  }

  ngOnInit() {
    if (this.selected) {
      this.getGroupName();
    }
  }

  public selectApp(id) {
    this.selected = id;
    this.getGroupName();
  }

  public save() {
    this.updateGroupName(this.appName.value);
  }

  private getGroupName() {
    console.log(this.selected)
    console.log(this.type);
    this.spinner.show();
    if (this.type === REQUEST_TYPE.ACCESS_REQUEST && this.selected !== 'GE_TAG_ID_REQUEST') {
      this.assignmentGroupService.getAccessRequestGroupName(this.selected).subscribe((res: any) => {
        this.spinner.hide();
        this.appName.setValue(res.data);
      });
    } else if (this.type === REQUEST_TYPE.ACCESS_REQUEST && this.selected === 'GE_TAG_ID_REQUEST') {
      this.assignmentGroupService.getAccessRequestGroupNameForGeTagId('GE_TAG_ID_REQUEST').subscribe((res: any) => {
        this.spinner.hide();
        this.appName.setValue(res.data);
      });
    } else {
      this.assignmentGroupService.getRevokeRequestGroupName(this.selected).subscribe((res: any) => {
        this.spinner.hide();
        this.appName.setValue(res.data);
      });
    }
  }

  private updateGroupName(name) {
    this.spinner.show();
    if (this.type === REQUEST_TYPE.ACCESS_REQUEST && this.selected !== 'GE_TAG_ID_REQUEST') {
      this.assignmentGroupService.updateAccessRequestGroupName(this.selected, name).subscribe((res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toastr.success(MESSAGE_TOAST.CHANGED_GROUP_NAME);
        }
      });
    } else if (this.type === REQUEST_TYPE.ACCESS_REQUEST && this.selected === 'GE_TAG_ID_REQUEST') {
      this.assignmentGroupService.updateAccessRequestGroupNameForGeTagId('GE_TAG_ID_REQUEST', name).subscribe((res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toastr.success(MESSAGE_TOAST.CHANGED_GROUP_NAME);
        }
      });
    } else {
      this.assignmentGroupService.updateRevokeRequestGroupName(this.selected, name).subscribe((res: any) => {
        this.spinner.hide();
        if (res.status) {
          this.toastr.success(MESSAGE_TOAST.CHANGED_GROUP_NAME);
        }
      });
    }
  }

}
